module.exports = __webpack_public_path__ + "img/logo-m2n.a2471e48.svg";